import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { IAppRootState } from '../../core/store';
import { homeReducer } from './home.reducer';
import { HomeSliceKey, HomeSliceState } from './home.state';
import { permissionReducer } from './permission.reducer';
import { PermissionSliceKey, PermissionSliceState } from './permission.state';
import { picsReducer } from './pics.reducer';
import { PicsSliceKey, PicsSliceState } from './pics.state';
import { projectOriginalReducer } from './project.reducer';
import { ProjectSliceState, ProjectSliceKey } from './project.state';

export const ProjectFeatureKey = 'Project';

export interface ProjectFeatureState {
	[ProjectSliceKey]: ProjectSliceState;
	[HomeSliceKey]: HomeSliceState;
	[PermissionSliceKey]: PermissionSliceState;
	[PicsSliceKey]: PicsSliceState;
}
export interface ProjectRootState extends IAppRootState {
	[ProjectFeatureKey]: ProjectFeatureState;
}
export const featureSelector =
	createFeatureSelector<ProjectFeatureState>(ProjectFeatureKey);
export const projectReducers: ActionReducerMap<ProjectFeatureState> = {
	[ProjectSliceKey]: projectOriginalReducer,
	[HomeSliceKey]: homeReducer,
	[PermissionSliceKey]: permissionReducer,
	[PicsSliceKey]: picsReducer,
};
